import _ from "lodash";
import {getCurrentUser} from "_helpers";
import {userInviteActions} from "_actions";
import {userInviteActionType} from "_constants";

export function submitAction(dispatch, userInvite, actionType) {
    if(_.isEmpty(userInvite)) return;
    const inviteId = userInvite?.id;

    switch (actionType) {
        case userInviteActionType.RESEND:
            return dispatch(userInviteActions.resend(inviteId, buildPayloadResendPayload()));
        case userInviteActionType.REVOKE:
            return dispatch(userInviteActions.revoke(inviteId));
        case userInviteActionType.UNREVOKE:
            return dispatch(userInviteActions.unrevoke(inviteId));
    }
}

export function buildCreatePayload(values) {
    const {id: userId} = getCurrentUser();
    return Object.assign(values, {invitedBy: userId});
}

export function excludeByKey(array, key, excludedValues) {
    return array.filter(item => !excludedValues.includes(item[key]));
}

export function formatRole(role) {
    if (!role) return '';

    return role
        .replace(/^ROLE_/, '')
        .split('_')
        .map(word => word.charAt(0) + word.slice(1).toLowerCase())
        .join(' ');
}

export function normalizeQueryParam(param) {
    if (!param) return [];
    if (Array.isArray(param)) return param;
    if (typeof param === 'string' && param.includes(',')) {
        return param.split(',').map(s => s.trim()).filter(Boolean);
    }
    return [param];
}

export const rolesForOrganization = ["ROLE_COMPANY_USER", "ROLE_COMPANY_ADMIN", "ROLE_CHATDESK_AGENT"];

function buildPayloadResendPayload() {
    const {id: userId} = getCurrentUser();
    return {
        resentBy: userId
    }
}